import React, { useState, useEffect } from 'react';

import { SingleLink } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { ContractorAttendanceInfo_SalaryMonthly } from '../../../../item/ItemContractorAttendance';

export function ContractorAttendanceEditSalaryMonthly({ contractorAttendance, salaryMonthly }) {
  const [mSalaryMonthly, setSalaryMonthly] = useState(new ContractorAttendanceInfo_SalaryMonthly({}))

  useEffect(() => {
    if (salaryMonthly !== undefined && mSalaryMonthly !== salaryMonthly) {
      console.log(salaryMonthly)
      setSalaryMonthly(salaryMonthly)
    }
  }, [salaryMonthly])

  function test(){

  }


  var title = <>出勤登錄計算-月薪-上工人數&nbsp;<span className="text-success">{mSalaryMonthly.Enrolment}</span>&nbsp;人</>
  var content =
    <>
      <div id="editable_wrapper" className="form-inline dt-bootstrap">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-striped table-bordered table-hover  dataTable">
              <thead>
                <tr role="row">
                  <th className="text-center sorting col-sm-2">項目名稱</th>
                  <th className="text-right sorting col-sm-2">合計金額</th>
                  <th className="text-center sorting col-sm-2">作業時間點</th>
                  <th className="text-center sorting col-sm-2">作業</th>
                  <th className="text-left sorting col-sm-2">提示</th>
                </tr>
              </thead>
              <tbody>
                <tr role="row">
                  <td className="text-center">底薪</td>
                  <td className="text-center">{mSalaryMonthly.BaseSalary.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.BaseSalary.ActionTime}</td>
                  <td className="text-center">
                    <SingleLink link={"ContractorAttendanceRegisterMonthly"}
                      name={"出勤及加減項登錄"}
                      Key={"salaryMonthly"}
                      val={{salaryMonthly: mSalaryMonthly, contractorAttendance}} >
                    </SingleLink>
                    </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">應付薪資</td>
                  <td className="text-center">{mSalaryMonthly.Salary.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.Salary.ActionTime}</td>
                  <td className="text-center">
                    <a href="#A" onClick={e => test()} >新增至薪資發放作業</a>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">廠商負擔保險費用</td>
                  <td className="text-center">{mSalaryMonthly.InsuranceCosts.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.InsuranceCosts.ActionTime}</td>
                  <td className="text-center">
                    <SingleLink link={"ContractorInsuranceCostMonthly"}
                      name={"保費計算"}
                      Key={"salaryMonthly"}
                      val={{salaryMonthly: mSalaryMonthly, contractorAttendance}} >
                    </SingleLink>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>
                <tr role="row">
                  <td className="text-center">服務費</td>
                  <td className="text-center">{mSalaryMonthly.ServiceFee.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.ServiceFee.ActionTime}</td>
                  <td className="text-center">--</td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">營業稅</td>
                  <td className="text-center">{mSalaryMonthly.Tax.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.Tax.ActionTime}</td>
                  <td className="text-center">--</td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">發票金額</td>
                  <td className="text-center">{mSalaryMonthly.Invoice.Amount}</td>
                  <td className="text-center">{mSalaryMonthly.Invoice.ActionTime}</td>
                  <td className="text-center">
                    <a href="#A" onClick={e => test()} >新增至請款作業</a>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

